export const UPDATE_SERVICE_TIME = "UPDATE_SERVICE_TIME";

export const updateServiceTime = (payload) => {
  return {type: UPDATE_SERVICE_TIME, payload}
}
